import React, { useContext, useEffect } from "react";
import { FormContext } from "./ImsAuditMainstage2";


function Stepper() {
  const { activeStepIndex } = useContext(FormContext);
  useEffect(() => {
    const stepperItems = document.querySelectorAll(".stepper-item");
    stepperItems.forEach((step, i) => {
      console.log("activeStepIndex",activeStepIndex)
      if (i <= activeStepIndex) {       
        console.log("if 11",i)
        step.classList.add("bg-danger","colorwhite");
      } else {
        console.log("else 11",i)
        step.classList.remove("bg-danger","colorwhite");
      }
    });
  }, [activeStepIndex]);
  return (
     <nav aria-label="Page navigation example">
      <ul class="pagination pagenumber">
    <li class="page-item"><span className="stepper-item">1</span></li>
    <li class="page-item"><span className="stepper-item">2</span></li>
    <li class="page-item"><span className="stepper-item">3</span></li>
    <li class="page-item"><span className="stepper-item">4</span></li>

  </ul>
  {/* <ul class="pagination">
   
    <li class="page-item">
        <div className="stepper-item pagenumber">
             1
       </div>
    </li>
    <li class="page-item">
    <div className="stepper-item pagenumber">
        2
       </div>
    </li>
    <li  class="page-item">
    <div className="stepper-item pagenumber">
         3
      </div>
    </li>
    <li  class="page-item">
    <div className="stepper-item pagenumber">
        4
      </div>
    </li>
    <li  class="page-item">
    <div className="stepper-item pagenumber">
        5
      </div>
    </li>
    <li  class="page-item">
    <div className="stepper-item pagenumber">
       6
      </div>
    </li>
    <li  class="page-item">
    <div className="stepper-item pagenumber">
       7
      </div>
    </li>
    <li  class="page-item">
    <div className="stepper-item pagenumber">
       8
      </div>
    </li>
  </ul> */}
</nav> 
  );
}

export default Stepper;